import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import DataDrivenLogo from '../../data-driven-logo';

import style from './data-driven-logo-column.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const DataDrivenLogoColumn = ({ message = '', isMultiple = false, isEmpty = false, dataDrivenLogoProps = emptyObject }) => {
  const isEmptyOrHasNoProps = isEmpty || Object.keys(dataDrivenLogoProps).length === 0;
  return (
    <div
      className={classnames(style['data-driven-logo-column'], {
        [style.multiple]: isMultiple,
      })}
    >
      {!isEmptyOrHasNoProps && isMultiple && (
        <FormattedMessage defaultMessage='(Multiple)' description='thirdPartyLogoColumn.multiple' id='GQLoY+' />
      )}
      {!isEmptyOrHasNoProps && !isMultiple && (
        <div className={style['normal-content']}>
          <DataDrivenLogo className={style['data-driven-logo']} logoType='icon' {...dataDrivenLogoProps} />
          <div className={style.message}>{message}</div>
        </div>
      )}
    </div>
  );
};

DataDrivenLogoColumn.propTypes = {
  message: PropTypes.string,
  isMultiple: PropTypes.bool,
  isEmpty: PropTypes.bool,
  dataDrivenLogoProps: PropTypes.shape({}),
};

export default React.memo(DataDrivenLogoColumn);
